import {
  FindByTpReferenceAndTpNameParams,
  ThirdPartyResponse,
  findByTpReferenceAndTpName,
} from 'services/thirdParty';
import { Form, Row, Tabs, notification } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { dateToString, toDatePickerDate } from 'utils/utils2';
import { isNaN, isNil } from 'lodash';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import ConcessionCreation from './TabConcession';
import DF from 'DisplayFramework';
import GetLabel from 'DisplayFramework/components/GetLabel';
import SuperCompanyCreation from './TabSuperCompany';
import TabCompany from './TabCompany';
import TabConcession from './TabConcession';
import TabPane from 'antd/lib/tabs/TabPane';
import TabSuperCompany from './TabSuperCompany';
import { getMyWizards } from 'services/workflow';
import moment from 'moment';
import { useGetThirdPartyDetail } from 'pages/ThirdParty/ThirdPartyDetail/useGetThirdPartyDetail';
import { useQuery } from 'react-query';

export type ThirdPartyDetailStepsProps = {
  tpId?: string;
  isUpdate?: boolean;
  isGrouping?: boolean;
  taskid?: number;
  isProposalCreate?: boolean;
  onSelect?: (item: ThirdPartyResponse) => void;
  isModal?: boolean;
};

const ThirdPartyCreation = (props: ThirdPartyDetailStepsProps) => {
  let { id, tptype } = useParams<{ id: string; tptype: 'CONC' | 'PM' | 'SPM' }>();
  const { taskid, onSelect, isModal, isUpdate, isGrouping } = props;

  const [searchParams] = useSearchParams();
  const isGroupingFromUrl = searchParams.get('isGrouping') === 'true';
  const finalIsGrouping = isGroupingFromUrl || isGrouping;


  const [createNewTP, setCreateNewTP] = useState<any>();
  const [tpList, setTpList] = useState<any[]>([]);

  const getId = () => {
    return props.tpId ? (props.tpId === '0' ? undefined : props.tpId) : id;
  };

  id = getId() as any;
  const navigate = useNavigate();

  const { data, refetch, isFetching } = useGetThirdPartyDetail(
    isNaN(Number(id)) ? undefined : Number(id),
    'TP'
  );

  const { data: wizData } = useQuery(['getMyWizards', 'THIRDPARTY'], () =>
    getMyWizards({ entity: 'THIRDPARTY' }).then((res) => res.data)
  );

  const [loadingBtn, setLoadingBtn] = useState(false);
  var thirdParty = data;

  const initialSearchParams: any = {
    parentid: 0,
    role: '',
    tpfiscalid: '',
    tpname: '',
    tpreference: '',
    tpcardid: '',
    tptype: '',
  };

  const [searchParamsState, setSearchParamsState] =
    useState<FindByTpReferenceAndTpNameParams>(initialSearchParams);

  const searchThirdparty = useCallback((tprefernce: string) => {
    findByTpReferenceAndTpName({ ...searchParamsState, tpreference: tprefernce })
      .then((response) => {
        if (response.code === '200') {
          setTpList(response.list);
        } else if (response.code === '404') {
          setCreateNewTP(true);
        }
      })
      .catch((response) => {
        notification.error({
          message: response.message,
        });
        setTpList([]);
      });
  }, [searchParamsState]);

  const keywordSearch = (e: any) => {
    if (e.target.value.length === 0 || e.target.value.length >= 3) {
      searchThirdparty(e.target.value);
    } else {
      return;
    }
  };

  return (
    <DF.Provider
      pagcode="tpcreationsteps"
      entity="THIRDPARTY"
      entityid={Number(id) || 0}
      additionalAttribute={{
        entity: 'THIRDPARTY',
        entitytype: tptype,
        object: 'THIRDPARTY',
      }}
    >
      <Tabs className='t'>
        {
          isUpdate ? (
            // Mode édition existant
            <>
              {tptype == "CONC" && <TabPane tab={<GetLabel label="concession" />} key="1">
                <ConcessionCreation isCreate={!isUpdate} />
              </TabPane>}

              {tptype == "SPM" && <TabPane tab={<GetLabel label="superthirdparty" />} key="2">
                <TabSuperCompany isCreate={!isUpdate} />
              </TabPane>}

              {tptype == "PM" && <TabPane tab={<GetLabel label="moralthirdparty" />} key="3">
                <TabCompany isGrouping={finalIsGrouping} isEditing />
              </TabPane>}
            </>
          ) : finalIsGrouping ? (
            // NOUVEAU - Mode regroupement automatique
            <TabPane tab={<GetLabel label="moralthirdparty" />} key="3">
              <TabCompany isGrouping={finalIsGrouping} isEditing />
            </TabPane>
          ) : (
            // Mode création normale
            <>
              <TabPane tab={<GetLabel label="concession" />} key="1">
                <TabConcession isCreate={!isUpdate} />
              </TabPane>

              <TabPane tab={<GetLabel label="superthirdparty" />} key="2">
                <TabSuperCompany isCreate={!isUpdate} />
              </TabPane>
            </>
          )
        }
      </Tabs>
    </DF.Provider>
  );
};

export default ThirdPartyCreation;